import { SharedModule } from './shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularmaterialModule } from './angular-material-module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ListFormSec002Component } from '../views/form-sec002/list-form-sec002.component';
import { FormSec002Component } from '../views/form-sec002/form-sec002.component';
import { FormSec002FilterComponent } from '../views/form-sec002/form-sec002-filter.component';
import { FormSec002RoutingModule } from '../routes/form-sec002.route';
import { Sec002CardIComponent } from '../views/form-sec002/partialViews/sec002-card-I.component';
import { Sec002CardIIComponent } from '../views/form-sec002/partialViews/sec002-card-II.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { Sec002CardIIIComponent } from '../views/form-sec002/partialViews/sec002-card-III.component';
import { Sec002CardIVComponent } from '../views/form-sec002/partialViews/sec002-card-IV.component';
import { Sec002CardVComponent } from '../views/form-sec002/partialViews/sec002-card-V.component';
import { Sec002CardVIComponent } from '../views/form-sec002/partialViews/sec002-card-VI.component';
import { Sec002CardVIIComponent } from '../views/form-sec002/partialViews/sec002-card-VII.component';
import { Sec002CardVIIIComponent } from '../views/form-sec002/partialViews/sec002-card-VIII.component';
import { Sec002CardIXComponent } from '../views/form-sec002/partialViews/sec002-card-IX.component';
import { Sec002CardXComponent } from '../views/form-sec002/partialViews/sec002-card-X.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.'
};

@NgModule({
    declarations: [
        ListFormSec002Component,
        FormSec002Component,
        FormSec002FilterComponent,
        Sec002CardIComponent,
        Sec002CardIIComponent,
        Sec002CardIIIComponent,
        Sec002CardIVComponent,
        Sec002CardVComponent,
        Sec002CardVIComponent,
        Sec002CardVIIComponent,
        Sec002CardVIIIComponent,
        Sec002CardIXComponent,
        Sec002CardXComponent,
    ],
    imports: [
        CommonModule,
        AngularmaterialModule,
        SharedModule,
        FormSec002RoutingModule,
        NgxMaskModule.forRoot(options),
        CurrencyMaskModule
    ],
    providers: [
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    ]
})

export class FormSec002Module {
}
